import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-508ef010"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "ant-row" }
const _hoisted_2 = { class: "ant-col ant-col-xs-24 ant-col-xl-12" }
const _hoisted_3 = { class: "ant-row" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ant-col ant-col-xs-24 ant-col-xl-6 ss-div-titulo" }, [
  /*#__PURE__*/_createElementVNode("span", null, "ICMS"),
  /*#__PURE__*/_createElementVNode("div", {
    class: "ant-divider ant-divider-vertical ss-div-separador ss-ocultar-mobile",
    role: "separator"
  })
], -1))
const _hoisted_5 = { class: "ant-col ant-col-xs-24 ant-col-18" }
const _hoisted_6 = { class: "ant-row" }
const _hoisted_7 = { class: "ant-col ant-col-xs-12 ant-col-xl-12" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "",
  title: "BC do ICMS"
}, "BC do ICMS", -1))
const _hoisted_9 = { class: "ant-col ant-col-xs-12 ant-col-xl-12" }
const _hoisted_10 = { class: "ant-col ant-col-xs-24 ant-col-xl-12" }
const _hoisted_11 = { class: "ant-row" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ant-col ant-col-xs-24 ant-col-xl-6 ss-div-titulo" }, [
  /*#__PURE__*/_createElementVNode("span", null, "IPI"),
  /*#__PURE__*/_createElementVNode("div", {
    class: "ant-divider ant-divider-vertical ss-div-separador ss-ocultar-mobile",
    role: "separator"
  })
], -1))
const _hoisted_13 = { class: "ant-col ant-col-xs-24 ant-col-18" }
const _hoisted_14 = { class: "ant-row" }
const _hoisted_15 = { class: "ant-col ant-col-xs-12 ant-col-xl-12" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "",
  title: "BC do ICMS"
}, "BC do IPI", -1))
const _hoisted_17 = { class: "ant-col ant-col-xs-12 ant-col-xl-12" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_campo_numerico = _resolveComponent("campo-numerico")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_card = _resolveComponent("card")!
  const _component_a_form = _resolveComponent("a-form")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_a_form, { layout: "vertical" }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createVNode(_component_card, { class: "ss-margin-totalizadores" }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_3, [
                  _hoisted_4,
                  _createElementVNode("div", _hoisted_5, [
                    _createElementVNode("div", _hoisted_6, [
                      _createElementVNode("div", _hoisted_7, [
                        _createVNode(_component_a_form_item, { class: "ss-margin-campos" }, {
                          label: _withCtx(() => [
                            _hoisted_8
                          ]),
                          default: _withCtx(() => [
                            _createVNode(_component_campo_numerico, {
                              quantidadeCasasDecimais: 2,
                              monetario: true,
                              valor: _ctx.computedImpostos.baseCalculoICMS,
                              "onUpdate:valor": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.computedImpostos.baseCalculoICMS) = $event)),
                              onValorDigitado: _cache[1] || (_cache[1] = ($event: any) => (_ctx.totalAlterado())),
                              disabled: !_ctx.props.editavel
                            }, null, 8, ["valor", "disabled"])
                          ]),
                          _: 1
                        })
                      ]),
                      _createElementVNode("div", _hoisted_9, [
                        _createVNode(_component_a_form_item, {
                          label: "Valor do ICMS",
                          class: "ss-margin-campos"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_campo_numerico, {
                              quantidadeCasasDecimais: 2,
                              monetario: true,
                              valor: _ctx.computedImpostos.valorIcms,
                              "onUpdate:valor": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.computedImpostos.valorIcms) = $event)),
                              onValorDigitado: _cache[3] || (_cache[3] = ($event: any) => (_ctx.totalAlterado())),
                              disabled: !_ctx.props.editavel
                            }, null, 8, ["valor", "disabled"])
                          ]),
                          _: 1
                        })
                      ])
                    ])
                  ])
                ])
              ]),
              _: 1
            })
          ]),
          _createElementVNode("div", _hoisted_10, [
            _createVNode(_component_card, { class: "ss-margin-totalizadores" }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_11, [
                  _hoisted_12,
                  _createElementVNode("div", _hoisted_13, [
                    _createElementVNode("div", _hoisted_14, [
                      _createElementVNode("div", _hoisted_15, [
                        _createVNode(_component_a_form_item, { class: "ss-margin-campos" }, {
                          label: _withCtx(() => [
                            _hoisted_16
                          ]),
                          default: _withCtx(() => [
                            _createVNode(_component_campo_numerico, {
                              quantidadeCasasDecimais: 2,
                              monetario: true,
                              valor: _ctx.computedImpostos.baseCalculoIpi,
                              "onUpdate:valor": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.computedImpostos.baseCalculoIpi) = $event)),
                              onValorDigitado: _cache[5] || (_cache[5] = ($event: any) => (_ctx.totalAlterado())),
                              disabled: !_ctx.props.editavel
                            }, null, 8, ["valor", "disabled"])
                          ]),
                          _: 1
                        })
                      ]),
                      _createElementVNode("div", _hoisted_17, [
                        _createVNode(_component_a_form_item, {
                          label: "Valor do ICMS",
                          class: "ss-margin-campos"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_campo_numerico, {
                              quantidadeCasasDecimais: 2,
                              monetario: true,
                              valor: _ctx.computedImpostos.valorIpi,
                              "onUpdate:valor": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.computedImpostos.valorIpi) = $event)),
                              onValorDigitado: _cache[7] || (_cache[7] = ($event: any) => (_ctx.totalAlterado())),
                              disabled: !_ctx.props.editavel
                            }, null, 8, ["valor", "disabled"])
                          ]),
                          _: 1
                        })
                      ])
                    ])
                  ])
                ])
              ]),
              _: 1
            })
          ])
        ])
      ]),
      _: 1
    })
  ]))
}